import React from 'react';
import { NavLink } from 'react-router-dom';

export default class NavBar extends React.Component {

    render(){
        var visibility = "hide";
 
        if (this.props.menuVisibility) {
        visibility = "show";
        }

        return (
            <div id="flyoutMenu"
            onMouseUp={this.props.handleMouseDown} 
            className={visibility}>
                <div className="navCon">
                    <h2 className="h2con">
                        <NavLink exact to="/" className="navl" activeClassName="active">Home</NavLink>
                    </h2>
                    <h2 className="h2con">
                        <NavLink to="/photos" className="navl" activeClassName="active">Photos</NavLink>
                    </h2>
                    <h2 className="h2con">
                        <NavLink to="/contact" className="navl" activeClassName="active">Contact</NavLink>
                    </h2>
                    <h2 className="h2con">
                        <NavLink to="/categories" className="navl" activeClassName="active">Categories</NavLink>
                    </h2>
                </div>    
            </div>
        );
    }
}